goog.provide("shadow.js.shim.module$ol$layer$Tile$default");
shadow.js.shim.module$ol$layer$Tile$default = shadow.js.require(398, {})["default"];
